import React, { forwardRef } from "react";

import { Icon } from "../components/icon";

const ExclaimCircleIcon = forwardRef<any, any>((props, ref) => (
  <Icon {...props} ref={ref}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 1.90735e-06C3.58172 1.90735e-06 1.90735e-06 3.58172 1.90735e-06 8C1.90735e-06 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 1.90735e-06 8 1.90735e-06Z"
    />
    <path
      d="M6.7991 8.95992L6.79904 8.70162L6.79914 3.03826C6.79913 2.87278 6.93653 2.73539 7.10276 2.73464L8.89926 2.73466C9.06549 2.73542 9.20251 2.87244 9.20251 3.03792L9.20247 6.29744L9.20247 8.96033C9.2021 9.12694 9.06546 9.26357 8.89923 9.26357L7.10273 9.26355C6.9365 9.26355 6.79948 9.12653 6.7991 8.95992Z"
      fill="white"
    />
    <circle
      cx="8.00977"
      cy="11.75"
      r="1.25"
      transform="rotate(-180 8.00977 11.75)"
      fill="white"
    />
  </Icon>
));

export { ExclaimCircleIcon };
